module.exports = __webpack_public_path__ + "img/header_Info.787c0a90.png";